const ABBREVIATIONS = [
  { sign: 'q', value: 1000000000000000 },
  { sign: 't', value: 1000000000000 },
  { sign: 'b', value: 1000000000 },
  { sign: 'm', value: 1000000 },
  { sign: 'k', value: 1000 },
];

// eslint-disable-next-line consistent-return
export function abbreviateNumber(number, fractionDigits = 1) {
  if (number < ABBREVIATIONS[ABBREVIATIONS.length - 1].value) {
    return number.toFixed(0);
  }

  let abbreviation;
  let i;
  for (i = 0; i < ABBREVIATIONS.length; i++) {
    abbreviation = ABBREVIATIONS[i];
    if (number >= abbreviation.value) {
      return (number / abbreviation.value).toFixed(fractionDigits) + abbreviation.sign;
    }
  }
}

export function percentTo5(score, fractionDigits = 1) {
  const isInfinite = !Number.isFinite(score);
  if (isInfinite) {
    return ' - ';
  }

  return (score / 20).toFixed(fractionDigits);
}
